import SftpReaderNode from './types/sftp-reader';
import SftpWriterNode from './types/sftp-writer';

export const sftpNodes = {
  sftpReader: SftpReaderNode,
  sftpWriter: SftpWriterNode,
};
